// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { Input } from '@/components/ui'
import type { OnboardingData } from '@/types'

interface Step4ContactProps {
  data:     Partial<OnboardingData>
  onChange: (updates: Partial<OnboardingData>) => void
  errors:   Partial<Record<keyof OnboardingData, string>>
}

export function Step4Contact({ data, onChange, errors }: Step4ContactProps) {
  return (
    <div className="flex flex-col gap-5">
      <div>
        <h2 className="text-lg font-semibold text-ink mb-1">Contactgegevens</h2>
        <p className="text-sm text-ink-3">
          Optioneel. Uw contactgegevens worden opgeslagen zodat u ze niet opnieuw hoeft in te vullen in uw persoonlijk gegevensscherm.
        </p>
      </div>

      <Input
        label="E-mailadres"
        type="email"
        value={data.email ?? ''}
        onChange={(e) => onChange({ email: e.target.value })}
        error={errors.email}
        placeholder="naam@voorbeeld.nl"
        autoComplete="email"
        hint="Optioneel - wordt overgenomen in uw persoonlijke gegevens"
      />

      <Input
        label="Telefoonnummer"
        type="tel"
        value={data.phone ?? ''}
        onChange={(e) => onChange({ phone: e.target.value })}
        error={errors.phone}
        placeholder="06 12 34 56 78"
        autoComplete="tel"
      />

      <p className="text-xs text-ink-4 bg-sand px-3.5 py-3 rounded-xl leading-relaxed">
        Contactgegevens worden versleuteld opgeslagen op uw apparaat.
        Wij sturen nooit e-mail zonder uw expliciete toestemming.
      </p>
    </div>
  )
}
